import React from 'react';

const currencies = ['USD', 'UGX', 'RWF'];

const CurrencySelector = ({ value = 'USD', onChange, className = '', disabled = false }) => {
  return (
    <div
      className={`flex rounded-lg border border-[#D8D9E8] overflow-hidden ${disabled ? 'opacity-50' : ''} ${className}`}
      data-testid="currency-selector"
    >
      {currencies.map((c) => (
        <button
          key={c}
          type="button"
          disabled={disabled}
          onClick={() => !disabled && onChange(c)}
          className={`px-3 py-1.5 text-sm font-medium transition-colors ${
            value === c
              ? 'bg-[#3E3F96] text-white'
              : 'bg-white text-[#5C635F] hover:bg-[#ECEDF5]'
          } ${disabled ? 'cursor-not-allowed' : ''}`}
          data-testid={`currency-${c}`}
        >
          {c}
        </button>
      ))}
    </div>
  );
};

export default CurrencySelector;
